import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons/faSort";
import { faSortDown } from "@fortawesome/free-solid-svg-icons/faSortDown";
import { faSortUp } from "@fortawesome/free-solid-svg-icons/faSortUp";
import styles from "./column-sort-container.less";
import { SortDirection } from "@tanstack/react-table";

type ColumnSortContainerProps = {
    id: string;
    isSorted: boolean | SortDirection;
};

export const ColumnSortContainer = (props: ColumnSortContainerProps) => {
    const { isSorted, id } = props;

    const sortIcon = useMemo(() => {
        if (!isSorted) {
            return faSort;
        } else if (isSorted === "asc") {
            return faSortDown;
        } else if (isSorted === "desc") {
            return faSortUp;
        }

        return null;
    }, [isSorted]);

    return <FontAwesomeIcon id={`${id}-icon`} className={styles.columnSortContainer} icon={sortIcon} />;
};